import React from 'react';
import classNames from 'classnames';

function SideBarTitle(props) {
	return <h4 className={classNames('c-neutral-900 fs-4 fw-600 pb-3', props.className)}>{props.children}</h4>;
}

export default SideBarTitle;
